import axios from "axios";

import C from "@constants/constants";

import { setupRefreshTokenInterceptor } from "@services/http.service";

type VersionType = "v1" | "v2";

const urls = {
  v1: `${C.VITE_APP_EXPRESS_SERVER}/1/`,
  v2: `${C.VITE_APP_NEST_SERVER}/v2/`,
};

const authedAxios = (version: VersionType) => {
  const baseURL = urls[version];

  const axiosInstance = axios.create({
    baseURL: baseURL,
    headers: {
      authorization: `Bearer ${localStorage.getItem(C.AUTH_TOKEN_KEY)}`,
    },
    withCredentials: true,
  });

  setupRefreshTokenInterceptor(axiosInstance);

  return axiosInstance;
};

export default authedAxios;
